<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card>
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="filter">
              <filter-component
                :filterOfAssociation="true"
                :filterOfBusinesses="true"
                :isRequiredFarms="false"
                :isRequiredLots="false"
                @filter="handleFilterRange"
                @showHideLoading="showHideLoading"
                classAssociation="col-12 col-sm-6 col-md-6 col-lg-4"
                classBusinesses="col-12 col-sm-6 col-md-6 col-lg-4"
                classFarms="col-12 col-sm-6 col-md-6 col-lg-4"
                classLots="col-12 col-sm-6 col-md-6 col-lg-4"
              >
                <template slot="prev">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-4 pt-3">
                    <label for="">{{ $t('common_words.evaluations') }}: </label>
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('evaluationsSel', evaluations)
                      "
                      clearable
                      collapse-tags
                      style="width: 100%"
                      multiple
                      filterable
                      class="select-primary custom-width-select shadow-sm"
                      v-model="evaluationsSel"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        class="select-primary selected-all"
                        v-for="item in evaluations"
                        :key="item.id + item.name"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </filter-component>
            </el-collapse-item>
          </el-collapse>
        </card>
        <card v-if="tableData.length > 0">
          <br />
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'date_save', order: 'descending' }"
                :data="queriedData"
                style="width: 100%"
                border
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                  :sortable="column.sortable"
                  :align="column.align"
                  :resizable="false"
                ></el-table-column>
                <el-table-column label="Imagen" min-width="170">
                  <template slot-scope="scope">
                    <el-image
                      v-if="scope.row.image"
                      :src="scope.row.image"
                      :alt="$t('common_words.no_image')"
                      class="photo_capture"
                      @click="zoom(scope.row.image)"
                      :preview-src-list="srcList"
                    >
                      <div slot="error" class="image-slot"></div>
                    </el-image>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="isShow() || isDelete()"
                  :min-width="120"
                  :label="$t('common_words.operations')"
                  fixed="right"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <span v-if="props.row.show">
                        <a
                          v-if="isShow()"
                          v-tooltip.top-center="$t('common_words.view')"
                          class="btn-info btn-simple btn-link custom-margin-actions"
                          @click="handleView(props.$index, props.row)"
                        >
                          <em class="fa fa-eye custom-size-fa-actions"></em>
                        </a>
                      </span>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
        <div v-if="details" class="col-12 text-center">
          <em
            class="nc-icon nc-stre-up"
            style="font-size: 25px; cursor: pointer"
            @click="handleViewDetails"
            v-tooltip.top-center="$t('common_words.hide_detail')"
          ></em>
        </div>
        <card v-if="details">
          <div class="row">
            <div class="col-12">
              <p style="font-size: 17px" class="text-muted">
                {{ $t('common_words.inspection_related_information') }}:
              </p>
            </div>
            <div class="col-10">
              <table class="table">
                <tbody>
                  <tr class="shadow-sm">
                    <td>
                      <img
                        v-tooltip.top-center="
                          $t('common_words.geo_location_map')
                        "
                        style="width: 30px; height: 30px"
                        class="pointer"
                        src="/static/img/iconos/map.svg"
                        alt="Icono de Geolocalización"
                        @click="handleViewSamplesMap()"
                      />
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.farm') }}:</strong>
                      </h6>
                      {{ rowData.farm_name }}
                    </td>
                    <td v-if="rowData.type_inspection_label != 'Por Finca'">
                      <h6>
                        <strong>{{ $t('common_words.allotment') }}:</strong>
                      </h6>
                      {{ rowData.lot_name }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.code') }}:</strong>
                      </h6>
                      {{ rowData.code }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.save_date') }}:</strong>
                      </h6>
                      {{ rowData.date_save }} | {{ $t('common_words.week') }}:
                      {{ rowData.week_save }}, {{ $t('common_words.day') }}:
                      {{ rowData.day_save }}
                    </td>
                    <td>
                      <h6>
                        <strong
                          >{{ $t('common_words.evaluation_type') }}:</strong
                        >
                      </h6>
                      {{ rowData.type_inspection_label }}
                      <h6 class="mt-3">
                        <strong>{{ $t('common_words.observation') }}:</strong>
                      </h6>
                      <span class="text-muted">{{ rowData.observations }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <el-dialog
              :title="$t('common_words.sample_map')"
              class="zoom-map el-dialog-img-zoom"
              top="15px"
              width="80%"
              :visible.sync="modals.samplesMap"
              :close="handleCloseSamplesMap"
            >
              <div ref="multipleMap" class="map"></div>
              <div id="toolbarDiv" class="esri-component esri-widget">
                <button
                  id="distance"
                  class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.distance_measurement_tool')"
                ></button>
                <button
                  id="area"
                  class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.area_measurement_tool')"
                ></button>
                <button
                  id="clear"
                  class="action-button esri-widget--button esri-interactive esri-icon-trash"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.clear_measurement')"
                ></button>
              </div>
            </el-dialog>
            <el-dialog
              v-if="isUpdate() && detailsForm.audit_inspection"
              :title="$t('common_words.inspection_edit_report')"
              :visible.sync="modals.read"
              width="80%"
              :close="handleClose"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <form @submit.prevent="validate" v-if="this.isUpdate()">
                <card class="shadow-sm">
                  <div class="row">
                    <div class="col-6">
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            1. {{ $t('common_words.geo_position_inspection') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="col-12">
                        <div ref="map" class="map" style="height: 430px"></div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            2.{{ $t('common_words.inspection_appraisal') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <div class="form-group has-label">
                            <el-select
                              clearable
                              class="select-primary custom-width-select shadow-sm required-value"
                              size="large"
                              v-model="detailsForm.value"
                              :placeholder="`${$t('common_words.select')}...`"
                              filterable
                            >
                              <template
                                v-if="
                                  detailsForm.audit_inspection
                                    .audit_head_with_trashed
                                    .calification_type == 1
                                "
                              >
                                <el-option
                                  v-for="(option, index) in [
                                    { id: 0, label: 'No' },
                                    { id: 1, label: 'Si' },
                                    { id: 3, label: 'NA' },
                                  ]"
                                  :key="index"
                                  class="select-primary"
                                  :value="option.id"
                                  :label="option.label"
                                ></el-option>
                              </template>
                              <template v-else>
                                <el-option
                                  v-for="(option, index) in 11"
                                  :key="index"
                                  class="select-primary"
                                  :value="index"
                                  :label="index"
                                ></el-option>
                                <el-option
                                  class="select-primary"
                                  :value="11"
                                  label="NA"
                                ></el-option>
                              </template>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            3. {{ $t('common_words.inspection_detail') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group has-label">
                            <label class="text-transform-none"
                              >{{
                                $t('common_words.associated_sub_category')
                              }}:</label
                            >
                            <el-input
                              v-bind:value="
                                detailsForm.audit_task_with_trashed
                                  ? detailsForm.audit_task_with_trashed
                                      .audit_subcategory_with_trashed.name
                                  : ''
                              "
                              :disabled="true"
                            >
                            </el-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group has-label">
                            <label class="text-transform-none"
                              >{{ $t('common_words.associated_task') }}:</label
                            >
                            <el-input
                              v-bind:value="
                                detailsForm.audit_task_with_trashed
                                  ? detailsForm.audit_task_with_trashed.name
                                  : ''
                              "
                              :disabled="true"
                            >
                            </el-input>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group has-label">
                            <div class="form-group has-label">
                              <label>{{
                                $t('common_words.observations')
                              }}</label>
                              <br />
                              <el-input
                                maxlength="300"
                                show-word-limit
                                class="shadow-sm"
                                type="textarea"
                                :rows="3"
                                v-model="detailsForm.observations"
                              ></el-input>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-12 text-right">
                      <button
                        type="submit"
                        class="btn btn-fill btn-info btn-wd shadow-sm"
                      >
                        {{ $t('common_words.edit') }}
                      </button>
                    </div>
                  </div>
                </card>
              </form>
              <br />
            </el-dialog>
            <div class="col-12">
              <hr />
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  clearable
                  @clear="paginationDetails.perPageD = 10"
                  filterable
                  class="select-default mb-3 shadow-sm"
                  style="width: 200px"
                  v-model="paginationDetails.perPageD"
                  :placeholder="$t('common_words.per_page')"
                >
                  <el-option
                    class="select-default"
                    v-for="item in paginationDetails.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <div class="row">
                  <div class="col-12">
                    <el-descriptions :column="2" border>
                      <el-descriptions-item>
                        <template slot="label">
                          <em class="el-icon-s-marketing"></em>
                          {{ $t('common_words.objective_average') }}
                        </template>
                        <span>{{
                          statisticDetails.totalObjective > 0
                            ? `${statisticDetails.avg_objective * 100}%`
                            : `----`
                        }}</span>
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label">
                          <em class="el-icon-s-marketing"></em>
                          {{ $t('common_words.subjective_average') }}
                        </template>
                        <span>
                          {{
                            statisticDetails.totalSubjective > 0
                              ? `${statisticDetails.avg_subjective * 10}%`
                              : `----`
                          }}</span
                        >
                      </el-descriptions-item>
                    </el-descriptions>
                  </div>
                </div>
                <el-input
                  clearable
                  class="mb-3 shadow-sm"
                  style="width: 200px"
                  :placeholder="$t('common_words.search_records')"
                  v-model="searchQueryDetails"
                  aria-controls="datatables"
                />
              </div>
              <el-table
                :cell-style="handlecellstyle"
                stripe
                :default-sort="{ prop: 'updated_at', order: 'descending' }"
                style="width: 100%"
                :data="queriedDataDetails"
                border
              >
                <el-table-column
                  v-for="column in tableColumnsDetails"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                ></el-table-column>
                <el-table-column :min-width="70" label="Acción" fixed="right">
                  <template slot-scope="props">
                    <div class="text-center">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="
                          props.row.audit_task_with_trashed.deleted_at
                            ? $t('common_words.record_edit_unavailable')
                            : $t('common_words.edit')
                        "
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="
                          !props.row.audit_task_with_trashed.deleted_at &&
                            handleEdit(props.$index, props.row)
                        "
                        :style="
                          props.row.audit_task_with_trashed.deleted_at
                            ? 'color: #888888'
                            : ''
                        "
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDeleteDetails(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <br />
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class>
                  <p class="card-category">
                    {{ $t('table2.showing') }} {{ fromDetails + 1 }}
                    {{ $t('table2.a') }} {{ toDetails }} {{ $t('table2.of') }}
                    {{ totalDetails }} {{ $t('table2.entries') }}
                  </p>
                </div>
                <l-pagination
                  class="pagination-no-border"
                  v-model="paginationDetails.currentPage"
                  :per-page="paginationDetails.perPage"
                  :total="paginationDetails.total"
                  pageFirst="false"
                  pageLast="false"
                ></l-pagination>
              </div>
            </div>
          </div>
          <div class="row" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { Pagination as LPagination } from 'src/components/index';
import { range } from 'src/util/Util.js';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import configTable from './inspectionTable';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [Filter.name]: Filter,
    LPagination,
  },

  computed: {
    ...configTable().searchDetails,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      activeName: 'filter',
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        evaluations: [],
        farm: [],
        lot: [],
      },
      details: false,
      detailsForm: {},
      evaluations: [],
      evaluationsSel: [],
      farms: [],
      farmSel: [],
      fuseSearch: null,
      fuseSearchDetails: null,
      inspectionForm: {},
      lotSel: [],
      map: null,
      modals: {
        read: false,
        samplesMap: false,
      },
      modelValidations: {
        task_id: {
          required: true,
        },
      },
      optTasks: [],
      pagination: {},
      paginationDetails: {},
      rowData: null,
      searchQuery: '',
      searchQueryDetails: '',
      srcList: [],
      subcategories: [],
      subcategory_id: null,
      tableColumns: [],
      tableColumnsDetails: [],
      tableData: [],
      tableDataDetails: [],
      valueCollapse: null,
      statisticDetails: {
        avg_objective: null,
        avg_subjective: null,
        subjectiveSum: null,
        totalObjective: null,
        totalObjectiveYes: null,
        totalSubjective: null,
      },
    };
  },

  mixins: [
    MixinArcgisMap,
    MixinExport,
    mixinMasters,
    MixinMenu,
    MixinNotification,
    MixinPermissions,
  ],
  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.evaluations = this.concatAll(this.evaluations.splice(1));
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    zoom(url) {
      this.srcList = [];
      this.srcList.push(url);
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    verifyLoadTask() {
      this.updateTask().then(() => {
        let is = true;
        for (
          let index = 0;
          index < Object.values(this.optTasks).length;
          index++
        ) {
          const element = Object.values(this.optTasks)[index];
          is = element.id == this.detailsForm.task_id;
          if (is) break;
        }

        if (!is) {
          this.detailsForm.task_id = null;
        }
      });
    },

    async updateTask() {
      return new Promise((resolve, reject) => {
        this.optTasks = Object.assign({}, []);
        let find = false;
        for (let index = 0; index < this.subcategories.length; index++) {
          const element = this.subcategories[index];
          if (this.subcategory_id == element.id) {
            find = element.task.length > 0 ? true : false;
            this.optTasks = Object.assign({}, find ? element.task : []);
            this.detailsForm.task_id =
              this.detailsForm.audit_task_with_trashed.audit_subcategory_id !=
              element.id
                ? null
                : this.detailsForm.task_id;
            resolve();
            break;
          }
        }

        reject(false);
      });
    },

    handlecellstyle({ row, columnIndex }) {
      if (
        columnIndex == 5 &&
        row.audit_inspection.audit_head_with_trashed.calification_type == 1
      ) {
        switch (row.value) {
          case 3:
            return 'background-color: #9d9d9d; color: white';
          case 0:
            return 'background-color: #ff4c4c; color: white';

          default:
            return 'background-color: #20a857; color: white';
        }
      } else {
        if (
          columnIndex == 5 &&
          row.audit_inspection.audit_head_with_trashed.calification_type == 2
        ) {
          if (row.value >= 0 && row.value <= 4)
            return 'background-color: #ff4c4c; color: white';
          if (row.value >= 5 && row.value <= 7)
            return 'background-color: #FEDB39; color: black';
          if (row.value >= 8 && row.value <= 10)
            return 'background-color: #20a857; color: white';
          if (row.value == 11 || row.value === 'NA')
            return 'background-color: #9d9d9d; color: white';
        } else {
          return '';
        }
      }
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          let typeCalification =
            this.detailsForm.audit_inspection.audit_head_with_trashed
              .calification_type;

          if (
            (typeCalification == 1 &&
              ![0, 1, 3].includes(this.detailsForm.value)) ||
            (typeCalification == 2 &&
              !range(0, 11).includes(this.detailsForm.value))
          ) {
            return store
              .dispatch('utils/validationInputsRequired', '-value')
              .catch((error) => console.log(error));
          } else {
            if (!this.subcategory_id) {
              return store
                .dispatch('utils/validationInputsRequired', '-subcategory')
                .catch((error) => console.log(error));
            } else {
              if (!this.detailsForm.task_id) {
                return store
                  .dispatch('utils/validationInputsRequired', '-task')
                  .catch((error) => console.log(error));
              } else {
                this.modals['read'] = false;
                this.showHideLoading(true);
                if (this.isUpdate()) {
                  this.detailsForm.route = 'audits/inspectionsdetails';
                  Axios.updateMaster(this.detailsForm)
                    .then((response) => {
                      this.showHideLoading();
                      SweetAlert.success(response.data.message).then(() => {
                        this.statisticDetails = response.data.data.pop();
                        this.$set(
                          this.tableDataDetails,
                          this.detailsForm.index,
                          response.data.data[0]
                        );
                      });
                    })
                    .catch((error) => {
                      this.showHideLoading();
                      this.showMessageErrors(error);
                    });
                } else {
                  this.showMessageAccess();
                  this.showHideLoading();
                }
              }
            }
          }
        }
      });
    },

    openModal(name) {
      this.modals[name] = true;
    },

    handleClose(done) {
      this.detailsForm = [];
    },

    handleCloseSamplesMap() {
      this.modals.samplesMap = false;
    },

    handleViewSamplesMap() {
      this.modals.samplesMap = true;
      this.showHideLoading(true);

      let points = [];
      this.tableDataDetails.forEach((element) => {
        let pll = new Object();
        pll.lat = parseFloat(element.latitude);
        pll.lng = parseFloat(element.longitude);

        this.center.lat = element.latitude
          ? parseFloat(element.latitude)
          : this.center.lat;
        this.center.lng = element.longitude
          ? parseFloat(element.longitude)
          : this.center.lng;

        points.push(pll);
      });

      setTimeout(() => {
        this.loadBaseMap(
          this.rowData.farm_id,
          true,
          true,
          this.$refs.multipleMap,
          points,
          19
        );
        document.getElementById('toolbarDiv').style = 'top: 16%;right: 18px;';
        this.showHideLoading();
      }, 10);
    },

    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        element.show = true;
      });
    },

    geoMap() {
      this.center.lat = this.detailsForm.latitude
        ? parseFloat(this.detailsForm.latitude)
        : this.center.lat;
      this.center.lng = this.detailsForm.longitude
        ? parseFloat(this.detailsForm.longitude)
        : this.center.lng;

      this.loadBaseMap(this.detailsForm.audit_inspection.farm_id);
    },

    handleEdit(index, row) {
      this.subcategory_id = null;
      this.detailsForm = Object.assign({}, row);
      this.detailsForm.index = index;
      this.center.lat = this.detailsForm.latitude
        ? parseFloat(this.detailsForm.latitude)
        : this.center.lat;
      this.center.lng = this.detailsForm.longitude
        ? parseFloat(this.detailsForm.longitude)
        : this.center.lng;
      this.subcategory_id =
        this.detailsForm.audit_task_with_trashed.audit_subcategory_id;
      this.modals['read'] = true;
      this.loadBaseMap(this.detailsForm.audit_inspection.farm_id);
      this.verifyLoadTask();
    },

    handleView(index, row) {
      this.showHideLoading(true);

      this.details = false;
      this.rowData = row;
      this.rowData.index = index;

      this.tableData.forEach((element) => {
        if (element.id != this.rowData.id) element.show = true;
        else this.rowData.show = false;
      });

      Promise.all([
        Axios.getMasters('audits/inspectionsdetails/' + this.rowData.code),
        Axios.getMasters('subcategories/' + this.rowData.evaluation_id),
      ])
        .then((response) => {
          const [responseDetails, responseSubCategories] = response;
          this.tableDataDetails = responseDetails.data.data;
          this.statisticDetails = this.tableDataDetails.pop();
          this.subcategories = responseSubCategories.data.data;

          this.fuseSearchDetails = new Fuse(this.tableDataDetails, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumnsDetails.map((column) => {
              return column.prop;
            }),
          });
          this.details = true;
          this.paginationDetails.currentPageDetails = 1;
          this.showHideLoading();

          setTimeout(() => {
            window.scrollTo({
              top: document.getElementsByClassName('footer')[0].offsetTop - 500,
              behavior: 'smooth',
            });

            let th = [...document.getElementsByTagName('th')].filter((th) => {
              return (
                th.innerHTML ===
                '<div class="cell">Cumplimiento o Calificación</div>'
              );
            });
            th[0].innerHTML = `<div class="cell">${
              this.rowData.type_calification === 'Subjetiva'
                ? `Calificación`
                : `Cumplimiento`
            }</div>`;
          }, 100);
        })
        .catch((error) => {
          this.showHideLoading();
          this.rowData.show = true;
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleDeleteDetails(index, row) {
      this.detailsForm = Object.assign({}, row);
      SweetAlert.delete(
        i18n.t('sweet_alert.audit.associated_data') +
          this.detailsForm.audit_task_with_trashed.name
      ).then((result) => {
        if (result.value) this.deleteDetail();
      });
    },

    handleDelete(index, row) {
      this.inspectionForm = Object.assign({}, row);
      SweetAlert.delete(
        i18n.t('sweet_alert.audit.code_audit') + this.inspectionForm.code
      ).then((result) => {
        if (result.value) this.deleteInspection();
      });
    },

    handleFilterRange(data) {
      this.dataFilter = { ...data };
      this.details = false;
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
      this.searchQuery = '';

      this.getDataSamples();
    },

    deleteDetail() {
      this.showHideLoading(true);
      if (this.isDelete()) {
        if (this.tableDataDetails.length == 1) {
          this.rowData.deleteHeader = true;
        }

        this.detailsForm.route = 'audits/inspectionsdetails';
        Axios.destroyMaster(this.detailsForm)
          .then((response) => {
            let indexToDelete = this.tableDataDetails.findIndex(
              (tableRow) => tableRow.id === this.detailsForm.id
            );
            if (indexToDelete >= 0) {
              this.tableDataDetails.splice(indexToDelete, 1);
              if (this.rowData.deleteHeader) {
                let indexToDelete = this.tableData.findIndex(
                  (tableRow) => tableRow.id === this.rowData.id
                );
                this.tableData.splice(indexToDelete, 1);
                this.details = false;
              }
            }

            this.statisticDetails = response.data.data;
            this.showHideLoading();
            this.showNotification(
              i18n.t('show_notification.audit.succesful_task_elimination'),
              'success',
              'nc-simple-remove',
              i18n.t('show_notification.audit.succesful_deletion')
            );
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    deleteInspection() {
      this.showHideLoading(true);
      if (this.isDelete()) {
        this.inspectionForm.route = 'audits/inspections';
        Axios.destroyMaster(this.inspectionForm)
          .then((response) => {
            this.modifyTable(2, this.inspectionForm.id, response);
            this.showHideLoading();
            this.handleViewDetails();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    exportToPDF() {
      this.PDF({
        route: 'audits/inspectionsdetails/pdf/' + this.rowData.code,
        name_file: 'informe.pdf',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      this.Excel({
        route: 'audits/inspectionsdetails/excel/' + this.rowData.code,
        name_file: 'informe.xlsx',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    getDataSamples() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'audits/inspections/filter';
      data.evaluations = this.evaluationsSel;
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(
              i18n.t('show_notification.audit.unavailable_data')
            );
          } else {
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((column) => {
                return column.prop;
              }),
            });
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table, TableDetails } = configTable();

      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;

      this.paginationDetails = { ...TableDetails.pagination };
      this.tableColumnsDetails = TableDetails.tableColumns;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      Axios.getMasters('audits/audits/inspections').then(
        (response) => (this.evaluations = this.concatAll(response.data.data))
      );
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('audits');
  },

  destroyed() {
    this.deselectedItemOnMenu('audits');
  },
};
</script>
<style></style>
